{
  "tabs": {
    "chat": "Babilejo",
    "reminders": "Memorigiloj",
    "calendar": "Kalendaro",
    "settings": "Agordoj"
  },
  "common": {
    "cancel": "Nuligi",
    "save": "Konservi",
    "confirm": "Konfirmi",
    "delete": "Forigi",
    "back": "Reen",
    "close": "Fermi",
    "edit": "Redakti",
    "search": "Serĉi",
    "all": "Ĉiuj",
    "loading": "Ŝarĝante...",
    "error": "Io misfunkciis",
    "notFound": "Ne trovita",
    "tryAgain": "Bonvolu reprovi",
    "retry": "Reprovi",
    "undo": "Malfari",
    "pullToRefresh": "Tiru por refreŝigi",
    "justNow": "ĝuste nun"
  },
  "auth": {
    "welcome": "Bonvenon al FishMemory",
    "tagline": "Via WhatsApp-memorigila asistanto, nun en via poŝo.",
    "subtitle": "Via WhatsApp-memorigila asistanto, nun en via poŝo.",
    "phoneLabel": "Via WhatsApp-numeron",
    "phoneHint": "Ni sendos konfirmkodon per WhatsApp",
    "invalidPhone": "Bonvolu enmeti validan telefonnumeron",
    "continue": "Daŭrigi",
    "enterPhone": "Enmetu vian WhatsApp-numeron",
    "phonePlaceholder": "Telefonnumero",
    "sendCode": "Sendi Kodon",
    "verifyTitle": "Konfirmu vian numeron",
    "otpSentTo": "6-cifra kodo estis sendita al {{phone}} per WhatsApp",
    "enterFullCode": "Bonvolu enmeti ĉiujn 6 ciferojn",
    "invalidOtp": "Nekonvena kodo. Bonvolu reprovi.",
    "otpFailed": "Malsukcesis sendi kodon. Provu denove.",
    "otpResent": "Kodo resendita",
    "resendIn": "Resendi en {{seconds}}s",
    "resendCode": "Resendi kodon",
    "enterOtp": "Enmetu la kodon senditan al via WhatsApp",
    "verify": "Konfirmi",
    "resend": "Resendi kodon",
    "wrongNumber": "Malĝusta numero?",
    "backToPhone": "Reen al telefono",
    "editPhone": "Redakti telefonon",
    "error": "Eraro",
    "setupTitle": "Ni agordu ĉion",
    "setupSubtitle": "Vi ĉiam povas ŝanĝi ĉi tion poste en Agordoj",
    "namePlaceholder": "Via nomo",
    "letsGo": "Fini agordon",
    "skipForNow": "Preterlasi nun"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Skribu mesaĝon...",
    "inputPlaceholder": "Skribu mesaĝon...",
    "typing": "FishMemory tajpas...",
    "online": "Rete",
    "connecting": "Konektante...",
    "reconnecting": "Rekonektante...",
    "offline": "Nete",
    "empty": "Komencu konversacion",
    "emptyHint": "Kreu memorigilojn, kontrolu vian horaron, aŭ petu helpon.",
    "emptyAction": "Sendi ekzemplan memorigilon",
    "actions": "Babilejaj agoj",
    "keep": "Konservi mesaĝojn",
    "clearTitle": "Forigi babilejon",
    "clearConfirm": "Ĉu forigi ĉiujn mesaĝojn de ĉi tiu aparato? Ĉi tio ne povas esti nuligita.",
    "clear": "Forigi babilejon",
    "optionSelected": "Elektita: {{label}}",
    "sendingSelection": "Sendante...",
    "connectionLost": "Rekonektante..."
  },
  "reminders": {
    "title": "Miaj Memorigiloj",
    "active": "Aktivaj",
    "today": "Hodiaŭ",
    "thisWeek": "Ĉi-semajne",
    "history": "Historio",
    "items": "eroj",
    "emptyTitle": "Neniuj memorigiloj ankoraŭ",
    "emptySubtitle": "Kreu unu en babilejo kaj ĝi aperos ĉi tie.",
    "emptyAction": "Malfermi babilejon",
    "filterActive": "Aktivaj",
    "filterToday": "Hodiaŭ",
    "filterWeek": "Ĉi-semajne",
    "filterHistory": "Historio",
    "emptyState": "Neniuj memorigiloj ankoraŭ. Komencu babili!",
    "swipeDone": "Fariĝis",
    "swipeSnooze": "Prokrasti",
    "swipeDelete": "Forigi",
    "search": "Serĉi memorigilojn...",
    "upcoming": "Baldaŭaj",
    "completed": "Finitaj",
    "overdue": "Malfruaj",
    "tomorrow": "Morgaŭ",
    "synced": "Sinkronigita {{value}}",
    "swipeHint": "Glitu memorigilon por pliaj agoj",
    "noResults": "Neniu memorigilo kongruas kun via serĉo",
    "noResultsHint": "Provu alian ŝlosilvorton aŭ malplenigu la serĉon",
    "deleteAllFailed": "Malsukcesis forigi ĉiujn memorigilojn"
  },
  "calendar": {
    "title": "Kalendaro",
    "today": "Hodiaŭ",
    "tomorrow": "Morgaŭ",
    "completed": "farita",
    "noEvents": "Nenio planita",
    "noEventsSubtitle": "Elektu daton por vidi memorigilojn kaj kalendarajn eventojn.",
    "googleEvent": "Google Kalendaro",
    "legendActive": "Aktiva",
    "legendRecurring": "Ripetiĝanta",
    "legendDone": "Fariĝis",
    "legendGoogle": "Google",
    "previousMonth": "Antaŭa monato",
    "nextMonth": "Sekva monato",
    "previousYear": "Antaŭa jaro",
    "nextYear": "Sekva jaro",
    "goToToday": "Iri al hodiaŭ",
    "all": "Ĉiuj",
    "active": "Aktivaj",
    "done": "Finitaj",
    "paused": "Paŭzitaj"
  },
  "settings": {
    "title": "Agordoj",
    "profile": "Profilo",
    "name": "Montri Nomon",
    "enterName": "Enmetu vian nomon",
    "language": "Lingvo",
    "uiLanguage": "App-lingvo",
    "uiLanguageHelp": "Ŝanĝas la uzantinterfacon, kalendarajn etikedo kaj aranĝon nur en ĉi tiu aparato.",
    "serverLanguage": "Babileja lingvo",
    "serverLanguageHelp": "Ŝanĝas la lingvon uzatan de servilaj respondoj kaj memorigilmesaĝoj por via konto.",
    "timezone": "Tempozono",
    "currentTimezone": "Nuna tempzono",
    "timezoneHelp": "Ĉiuj memorigilaj tempoj estas montrataj uzante ĉi tiun tempzonon.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Konservi tempzonon",
    "timezoneSaved": "Tempzono ĝisdatigita",
    "detect": "Detekti",
    "detectFailed": "Ne eblis detekti tempzonon",
    "autoDetect": "Aŭtomate detekti per GPS",
    "notifications": "Sciigoj",
    "notificationsHelp": "Sekvaj memorigiloj regas ripetajn atentigojn post kiam memorigilo estas liverita. Permesoj por aparato-nivela sciigoj estas administrataj en via telefonaj agordoj.",
    "pushEnabled": "Puŝaj Sciigoj",
    "autoDoneOnFire": "Aŭtomate marki farita kiam ekfunkciita",
    "autoDoneOnFireDesc": "Kiam malŝaltita, memorigiloj restas aktivaj ĝis vi markas ilin faritaj.",
    "googleCalendar": "Google Kalendaro",
    "google": "Google Kalendaro",
    "googleConnected": "Konektita",
    "googleDisconnected": "Ne konektita",
    "googleConnectedHelp": "Novaj memorigiloj povas esti sinkronigitaj al via kalendaro aŭtomate.",
    "googleDisconnectedHelp": "Konektu Google Kalendaron por konservi memorigilojn kaj eventojn sinkronigitaj.",
    "googleConnectFailed": "Malsukcesis konekti Google Kalendaron",
    "connected": "Konektita",
    "disconnected": "Ne konektita",
    "connect": "Konekti",
    "disconnect": "Malkonekti",
    "autoSync": "Aŭtomata sinkronigo de novaj memorigiloj",
    "autosync": "Aŭtomata sinkronigo de novaj memorigiloj",
    "subscription": "Abono",
    "trialUsed": "Provo: {{used}}/{{total}} uzitaj",
    "trialStatus": "Provo disponebla",
    "activeStatus": "Aktiva abono",
    "expiredStatus": "Abono eksvalidiĝis",
    "unsubscribedStatus": "Ne abonita",
    "about": "Pri",
    "version": "Versio",
    "logout": "Elsaluti",
    "logoutTitle": "Elsaluti",
    "logoutConfirm": "Ĉu vi certas, ke vi volas elsaluti?",
    "noName": "Neniu nomo agordita",
    "serverConnection": "Servila konekto",
    "serverUrl": "Servila URL",
    "serverEdit": "Redakti",
    "saveReconnect": "Konservi kaj rekonekti",
    "resetDefault": "Restarigi defaŭlton",
    "invalidServerUrlTitle": "Nekonvena servila URL",
    "invalidServerUrlMessage": "Enmetu validan http aŭ https servilan URL, ekzemple https://example.com",
    "uiLanguageChangeFailed": "Malsukcesis ŝanĝi app-lingvon. Bonvolu reprovi.",
    "serverLanguageChangeFailed": "Malsukcesis ŝanĝi babilejan lingvon. Bonvolu reprovi.",
    "timezoneChangeFailed": "Malsukcesis ŝanĝi tempzonon. Bonvolu reprovi.",
    "autoSyncChangeFailed": "Malsukcesis ĝisdatigi aŭtomatan sinkronigon. Bonvolu reprovi.",
    "nameChangeFailed": "Malsukcesis ĝisdatigi montratan nomon. Bonvolu reprovi.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Detaloj de memorigilo",
    "editTime": "Redakti tempon",
    "rename": "Renomi",
    "snooze": "Prokrasti",
    "snooze15": "Prokrasti 15 minutojn",
    "pause": "Paŭzi",
    "pauseReminder": "Paŭzi memorigilon",
    "resume": "Daŭrigi",
    "resumeReminder": "Daŭrigi memorigilon",
    "skip": "Preterlasi sekvan",
    "skipOccurrence": "Preterlasi ĉi tiun okazigon",
    "syncGoogle": "Sinkronigi al Google",
    "delete": "Forigi",
    "deleteTitle": "Forigi Memorigilon",
    "deleteConfirm": "Ĉi tiu memorigilo estos definitive forigita.",
    "deleteRecurringTitle": "Forigi Ripetantan Memorigilon",
    "deleteRecurringMessage": "Ĉu vi volas preterlasi ĉi tiun okazigon aŭ forigi la tutan serion?",
    "deleteThisOccurrence": "Preterlasi Ĉi Tiun Okazigon",
    "deleteEntireSeries": "Forigi Tutan Serion",
    "done": "Fariĝis",
    "markDone": "Marki kiel farita",
    "undo": "Restarigi",
    "undoPrompt": "Ĉu vi bezonas ĝin denove aktiva? Restarigu ĝin nun.",
    "recurring": "Ripetiĝanta",
    "nextRun": "Sekva kurado",
    "oneTime": "Unufoja",
    "pending": "Atendanta",
    "sent": "Sendita",
    "paused": "Paŭzita",
    "active": "Aktiva",
    "snoozed": "Prokrastita",
    "localTime": "Montrita en via loka tempo",
    "recurrence": "Ripetiĝo",
    "created": "Kreita",
    "tags": "Etikedoj",
    "fireCount": "Fojoj ekfunkciita",
    "actions": "Agoj",
    "none": "Neniu",
    "snoozeFailed": "Malsukcesis prokrasti memorigilon",
    "pauseFailed": "Malsukcesis paŭzi memorigilon",
    "resumeFailed": "Malsukcesis daŭrigi memorigilon",
    "skipFailed": "Malsukcesis preterlasi memorigilon",
    "doneFailed": "Malsukcesis marki memorigilon kiel farita",
    "undoFailed": "Malsukcesis restarigi memorigilan staton",
    "deleteFailed": "Malsukcesis forigi memorigilon",
    "rescheduleTitle": "Replanigi?",
    "rescheduleMsg": "Ĉi tiu memorigilo estas malfrua. Ĉu vi volas replanigi ĝin?",
    "reschedule15": "Post 15 minutoj",
    "reschedule60": "Post 1 horo",
    "keepOverdue": "Konservi kiel estas"
  },
  "onboarding": {
    "slide1Title": "Bonvenon al FishMemory",
    "slide1Sub": "Via persona memorigila asistanto — funkciigita de WhatsApp kaj desegnita por via poŝo.",
    "slide2Title": "Simple Babile Nature",
    "slide2Sub": "Skribu memorigilojn tiel kiel vi pensas: \"Rememorigas min telefoni al patrino morgaŭ je la 15a\" — ni prizorgas la reston.",
    "slide3Title": "Neniam Maltrafu Ion",
    "slide3Sub": "Ricevu ĝustatempajn sciigojn, organizu per etikedoj, kaj restu super ĉio grava.",
    "getStarted": "Komenci",
    "next": "Sekva",
    "firstReminderTitle": "Kreu vian unuan memorigilon!",
    "firstReminderHint": "Provu skribi ion kiel:",
    "firstReminderExample": "Rememorigas min trinki akvon morgaŭ je la 9a matene",
    "gotIt": "Komprenite!",
    "notifRationaleTitle": "Restu ĝustatempe",
    "notifRationaleBody": "FishMemory bezonas sciigojn por memorigadi vin ĝustatempe. Vi ricevos atentigojn nur por memorigiloj, kiujn vi kreas.",
    "notifRationaleAllow": "Permesi Sciigojn",
    "notifRationaleLater": "Eble Poste",
    "swipeHint": "Glitu dekstren por rapidaj agoj →",
    "calendarDragHint": "Tiru por etendi ↕"
  }
}
